import { useEffect, useState } from 'react';
import imgDcotersgroup from './../images/docter-group-img.png';
import imgShapefour from './../images/shape-4.svg';
import imgShapefive from './../images/Stetoscope.png';
import getPageContent from '../api/PageContentService';

export default function WhatIsDoctolink() {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        getPageContent('que-es-doctolink', setError)
            .then((res) => {
                setData(res || null);
            })
            .catch(() => {
                setError('Unable to load page content.');
            });
    }, []);

    if (error) {
        return <p className="p-5 text-center text-red-500">{error}</p>;
    }

    if (!data) {
        return <p className="p-5 text-center">Loading...</p>;
    }

    const fields = data?.fields || [];

    const whatIsDoctolink = fields.find((f) => f.uniqueyKey === '¿Qué es Doctolink?');
    console.log(whatIsDoctolink, 'whatIsDoctolink');
    const ourGoal = fields.find((f) => f.uniqueyKey === '¿Cuál es nuestro objetivo?');

    const fieldName1 = whatIsDoctolink?.fieldName || '';
    console.log(fieldName1, 'fieldName1');
    const fieldValue1 = whatIsDoctolink?.fieldValue || '';

    const fieldName2 = ourGoal?.fieldName || '';
    const fieldValue2 = ourGoal?.fieldValue || '';

    return (
        <div>
            <div className="pt-60 pb-60 whta-is-docter-link-box-main">
                <div className="whta-is-docter-link-box">
                    <div className="wrapper-box">
                        <div className="what-is-docter-link-box-inner">
                            <div className="grid grid-cols-2 h-full">
                                <div className="what-is-docter-link-box-L">
                                    <blockquote>
                                        <h2 className="docter-team-title">{fieldName1}</h2>
                                        <p className="docter-team-sub-title">{fieldValue1}</p>
                                    </blockquote>
                                </div>

                                <div className="what-is-docter-link-box-R">
                                    <figure className="img-box">
                                        <img src={imgDcotersgroup} alt="Doctor group" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pt-40 whta-is-docter-link-bottom">
                    <div className="what-is-our-goal-box">
                        <div className="what-is-our-goal">
                            <figure className="shape-5">
                                <img src={imgShapefive} alt="Stethoscope" />
                            </figure>

                            <blockquote>
                                <h2 className="docter-team-title">{fieldName2}</h2>
                                <p className="docter-team-sub-title">{fieldValue2}</p>
                            </blockquote>
                        </div>

                        <figure className="shape-4">
                            <img src={imgShapefour} alt="Shape" />
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    );
}
